import styled from '@emotion/styled';
import { brandNeutralColors } from 'ui_system/compass/utils/theme';
import { BaseSelect } from 'ui_system/forms/BaseSelect';

export const LanguageHeader = styled.div`
  height: 80px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 25px;
  background: ${brandNeutralColors.background.light};
  width: 100%;
`;

export const LanguageSelector = styled(BaseSelect)`
  max-width: 180px;
  width: 100%;
`;
